import { render, staticRenderFns } from "./QuizEventPreview.vue?vue&type=template&id=40784781&scoped=true&"
import script from "./QuizEventPreview.vue?vue&type=script&lang=ts&"
export * from "./QuizEventPreview.vue?vue&type=script&lang=ts&"
import style0 from "./QuizEventPreview.vue?vue&type=style&index=0&id=40784781&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40784781",
  null
  
)

export default component.exports